export default __webpack_public_path__ + "static/media/logo_campaign_gift.1e5cdc71.png";